import Vue from "vue";
import Router from "vue-router";
import Directory from "@/components/Directory";
import Profile from "@/components/Profile";
import About from "@/components/About";
import LandingPage from "@/components/LandingPage"

Vue.use(Router);

export default new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: "/data",
      name: "Landing",
      component: LandingPage
    },
    {
      path: "/",
      name: "Directory",
      component: Directory
    },
    {
      path: "/profile/:providerName",
      name: "Profile",
      component: Profile
    },
    {
      path: "/about",
      name: "About",
      component: About
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js